import { createRoute, useNavigate, useSearch } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PantryView } from "@/features/pantry/components/pantry-view";
import { PageContainer } from "@fleet/ui";

interface PantrySearch {
  /** "Recipes with <ingredient>" panel (`?ingredient=<name>`). */
  ingredient?: string;
}

function PantryPage() {
  const search = useSearch({ from: "/_app/pantry" });
  const navigate = useNavigate();

  // The discovery panel "recipes with <ingredient>" is deep-linkable
  // (`?ingredient=`): the URL is the source of truth to open/close the panel.
  const setIngredient = (ingredient: string): void => {
    const trimmed = ingredient.trim();
    if (trimmed === (search().ingredient ?? "")) {
      return;
    }
    void navigate({
      to: "/pantry",
      search: trimmed ? { ingredient: trimmed } : {},
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="3xl">
      <PantryView selectedIngredient={search().ingredient} onIngredientChange={setIngredient} />
    </PageContainer>
  );
}

export const pantryRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/pantry",
  validateSearch: (search: Record<string, unknown>): PantrySearch => ({
    ingredient:
      typeof search.ingredient === "string" && search.ingredient.trim() !== ""
        ? search.ingredient
        : undefined,
  }),
  component: PantryPage,
});
